import { render, staticRenderFns } from "./account-details.vue?vue&type=template&id=2297b689&scoped=true&"
import script from "./account-details.vue?vue&type=script&lang=js&"
export * from "./account-details.vue?vue&type=script&lang=js&"
import style0 from "./account-details.vue?vue&type=style&index=0&id=2297b689&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297b689",
  null
  
)

export default component.exports